// Import the functions you need from the SDKs you need
// import firebase from "firebase/app";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDkowAoYhY-ChayOHYtXg6hs3uYYHIf3VI",
  authDomain: "sure-accounts.firebaseapp.com",
  projectId: "sure-accounts",
  storageBucket: "sure-accounts.appspot.com",
  messagingSenderId: "761909819138",
  appId: "1:761909819138:web:05964aecf92e719912741b",
  measurementId: "G-NHPCJ12JBX",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const analytics = getAnalytics(app);

export { auth, provider, signInWithPopup };
